import { calendar } from "@planzone/dto";
import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveCalendarRequestFailure(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.request.isFailure : false;
    },
    isRetrieveCalendarRequestPending(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.request.isPending : false;
    },
    isRetrieveCalendarRequestSuccess(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.request.isSuccessful : false;
    },
    getCalendar(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.calendar : calendar;
    },
  };
}

export { createSelector };
